import { createApp } from "vue";
import App from "./App.vue";
import "./style.css";
import router from "./router";
import store from "./store";

import { DefaultApolloClient } from "@vue/apollo-composable";
import { apolloClient } from "./apollo"; // Apollo config file

const app = createApp(App);

// Provide Apollo Client globally
app.provide(DefaultApolloClient, apolloClient);

// Use router and store on the same app instance
app.use(store);
app.use(router);

app.mount("#app");
